module.exports = __webpack_public_path__ + "img/AGR-A-2-II.eb4a6ef4.png";